/**
 * **Welches Feld leer ist — bevor gefragt wird** (Durchgang 03.10.2026, A-01).
 * Bis dahin ging die leere Eingabe an den Server, und der antwortete mit
 * „Prüfe das Feld, das rot umrandet ist" — ohne dass eines rot umrandet war.
 * Leerzeichen zählen als leer; die E-Mail kommt zuerst, weil sie oben steht.
 */
export function leeresFeld(mail: string, wort: string): "mail" | "wort" | null {
  if (!mail.trim()) return "mail";
  if (!wort) return "wort";
  return null;
}
